import QuoteWinIn from 'elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWinIn';
import { channelObj } from '@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteForm';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
const QuoteWinInSimple = dynamic(() => import('@elem/compCommon/ProductConstructor/BriefGuide/Info/QuoteWinInSimple'), { ssr: false });
import styles from './index.module.scss';
import PageLayout from '@/components/PageLayout';

export default function EfQuoteForm({ SEO }: any) {
    const { locale, query } = useRouter();
    const queryChannel = channelObj[query?.channel as 'community'];

    return (
        <PageLayout theme="white">
            {locale === 'us' && queryChannel ? <QuoteWinInSimple className={styles.efquoteform} /> : <QuoteWinIn className={styles.efquoteform} />}
        </PageLayout>
    );
}
